const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '招标采购信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')
var dayjs = require('dayjs')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
            // form: {}, // 审批基础数据
            zbGgXX: {}, // 招标公告信息
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
            this.getZbGgXX()
        },
        getBaseInfo() {
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/cggg/zbGc.do`, {
                bdGuid: this.form.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '项目名称': res.data.gcName,
                    '项目编号': res.data.gcBH,
                    '项目类型': getProjectTypeName(res.data.xmLeiXing),
                    '采购方式': getPurchaseTypeName(res.data.zbFangShi),
                    '行业分类': res.data.hangYe_BH,
                    '基本要求': '',
                }
            })
        },
        getZbGgXX() {
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/cggg/zbGgXX.do`, {
                ggGuid: this.form.ggGuid,
            }).then((res) => {
                this.zbGgXX = res.data
            })
        },
        pass() {
            // ggXingZhi: '',// 公告性质(1:正常公告/2:更正公告)
            if (this.zbGgXX.ggXingZhi == null) { // 如果正常公告 ，公告开始时间过了的话 不让提交审核
                if (this.zbGgXX.ggStartTime < dayjs().valueOf()) {
                    this.$errorInfo('公告开始时间已开始，公告已被自动退回!')
                    return
                }
            }
            this.commit()
        },
        fail(opinion) {
            // ggXingZhi: '',// 公告性质(1:正常公告/2:更正公告)
            if (this.zbGgXX.ggXingZhi == null) { // 如果正常公告 ，公告开始时间过了的话 不让提交审核
                if (this.zbGgXX.ggStartTime < dayjs().valueOf()) {
                    this.$errorInfo('公告开始时间已开始，公告已被自动退回!')
                    return
                }
            }
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
